import { render, staticRenderFns } from "./HistoricoMarcacoes.vue?vue&type=template&id=05ff1f6c&"
import script from "./HistoricoMarcacoes.vue?vue&type=script&lang=js&"
export * from "./HistoricoMarcacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports